import registerConstants from '../../register/constants/register-constants';

const campaigns_table_head_items = [
  {
    label: 'CAMPAIGNS.LINK_NAME',
  },
  {
    label: 'CAMPAIGNS.REF_CODE',
  },
  {
    label: 'CAMPAIGNS.INSTALLS',
    forbidden_user_types: [registerConstants.user_types.ifs_type],
  },
  {
    label: 'CAMPAIGNS.DEMO_CLIENTS',
    forbidden_user_types: [registerConstants.user_types.ifs_type],
  },
  {
    label: 'CAMPAIGNS.LIVE_CLIENTS',
    forbidden_user_types: [registerConstants.user_types.ifs_type],
  },
  {
    label: 'CAMPAIGNS.DEPOSITS',
  },
  {
    label: 'CAMPAIGNS.WITHDRAWALS',
  },
  {
    label: 'CAMPAIGNS.NET_DEPOSITS',
  },
  {
    label: 'CAMPAIGNS.TRADES',
  },
  {
    label: 'CAMPAIGNS.QUALIFIED_TRADES',
  },
  {
    label: 'CAMPAIGNS.TRADING_LOTS',
  },
  {
    label: 'CAMPAIGNS.QUALIFIED_LOTS',
  },
  {
    label: 'CAMPAIGNS.TOTAL_COMMISSION',
  },
  {
    label: 'CAMPAIGNS.COMMISSION_FROM_TRADING',
  },
  {
    label: 'CAMPAIGNS.COMMISSION_FROM_ACHIEVEMENTS',
  },
  {
    label: 'CAMPAIGNS.PENDING_COMMISSION',
  },
  {
    label: 'CAMPAIGNS.TARGET_SITE',
  },
  {
    label: 'CAMPAIGNS.ACTION',
  },
];

const ib_ifs_user_hidden_labels = ['CAMPAIGNS.COMMISSION_FROM_TRADING', 'CAMPAIGNS.COMMISSION_FROM_ACHIEVEMENTS', 'CAMPAIGNS.PENDING_COMMISSION'];

const create_campaign_form = 'createCampaignForm';

const fields = {
  name: 'name',
  invite_link: 'invite_link',
};

const campaign_types = {
  web: {
    value: 'web',
    label: 'CAMPAIGNS.WEB_TRAFFIC',
  },
  mobile: {
    value: 'mobile',
    label: 'CAMPAIGNS.MOBILE_TRAFFIC',
  },
};

const link_types = {
  partner: 'partner',
  installation: 'installation',
};

const special_campaigns = ['BTC50'];

export default {
  campaigns_table_head_items,
  ib_ifs_user_hidden_labels,
  create_campaign_form,
  fields,
  campaign_types,
  link_types,
  special_campaigns,
};



// WEBPACK FOOTER //
// ./src/app/main/campaigns/constants/campaigns-constants.js